module.exports = __webpack_public_path__ + "img/box.8318337d.svg";